import { EmploymentPayData } from '../types';

/**
 * Calculates if the input pay data row has different values compared to the already reported payAmount and attributablePay
 * @param payRow
 * @returns
 */
export const hasInputPayDataChangedComparedToReported = (payRow: EmploymentPayData): boolean => {
  const { payAmount, payAmountReported, attributablePay, attributablePayReported } = payRow;

  // Check if the payAmount differs from the reported amount
  if (payAmount !== payAmountReported) {
    return true;
  }

  // Check if the number of attributable pay months is different
  const attributablePayLength = attributablePay?.length ?? 0;
  const attributablePayReportedLength = attributablePayReported?.length ?? 0;
  if (attributablePayLength !== attributablePayReportedLength) {
    return true;
  }

  // Compare each month of attributable pay
  return (
    attributablePay?.some(({ attributablePayMonth, attributablePayAmount }) => {
      const reportedPay = attributablePayReported?.find(
        ({ attributablePayMonth: reportedMonth }) => reportedMonth === attributablePayMonth
      );

      // Check if the month exists in the reported data or if the amounts differ
      return !reportedPay || attributablePayAmount !== reportedPay.attributablePayAmount;
    }) ?? false
  );
};
